import React from "react";
import { Link } from "react-router-dom";
import visionLogo from "../../images/vision-logo.png";
import { monthNames } from "../helpers/date";
import Profile from "./Profile";

function Header() {
  let newDate = new Date();
  
  return (
    <header className="fixed-top">
      <section className="navbar navbar-expand-md navbar-white bg-white px-3 cpy-12">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/veg-art">
            <img src={visionLogo} alt="" width="150" height="35" />
          </Link>
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item px-1 d-flex">
              <a href="#" className="nav-link d-flex align-items-center">
                <i className="icon icon-users fs-20 text-dark"></i>
              </a>
            </li>
            <li className="nav-item px-1 d-flex">
              <a href="#" className="nav-link d-flex align-items-center">
                <i className="icon icon-setting fs-20 text-dark"></i>
              </a>
            </li>
            <li className="nav-item px-1 d-flex">
              <a href="#" className="nav-link d-flex align-items-center">
                <i className="icon icon-notification fs-20 text-dark"></i>
              </a>
            </li>
            <li className="nav-item ms-3">
              <Profile />
            </li>
          </ul>
        </div>
      </section>
      <nav className="navbar navbar-expand-md bg-primary p-1">
        <div className="container-fluid">
          <ul className="navbar-nav mb-lg-0 d-flex align-items-center w-100">
            <li className="me-auto"></li>
            <li className="nav-item px-3">
              <Link to="/veg-art" className="nav-link text-white fs-15">
                Home
              </Link>
            </li>
            <li className="nav-item dropdown px-3">
              <a
                href="#"
                className="nav-link text-white fs-15 dropdown-toggle"
                id="orders"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Orders
              </a>
              <ul
                className="dropdown-menu border-0 shadow-lg"
                aria-labelledby="orders"
                style={{ minWidth: "12rem" }}
              >
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/all-orders"
                  >
                    <i className="icon icon-order me-2"></i> All Orders
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/enter-order"
                  >
                    <i className="icon icon-enter me-2"></i>Enter Order
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/print-order"
                  >
                    <i className="icon icon-print me-2"></i>Print Order
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/on-hand-order"
                  >
                    <i className="icon icon-onhand me-2"></i>On Hand Order
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/enter-buying-price"
                  >
                    <i className="icon icon-amount me-2"></i>Enter Buy Price
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item fs-15 py-1" to="/finalise-order">
                    <i className="icon icon-done me-2"></i>Finalise Order
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown px-3">
              <a
                href="#"
                className="nav-link text-white fs-15 dropdown-toggle"
                id="credits"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Credits/Invoices
              </a>
              <ul
                className="dropdown-menu border-0 shadow-lg"
                aria-labelledby="credits"
                style={{ minWidth: "15rem" }}
              >
                <li>
                  <Link className="dropdown-item fs-15 py-1"
                    to="/crate-credits"
                  >
                    <i className="icon icon-money me-2"></i>Enter Crate Credits
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item fs-15 py-1" to="/produce-credits">
                    <i className="icon icon-receipt me-2"></i> Enter Produce
                    Credits
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item fs-15 py-1" to="/all-invoices">
                    <i className="icon icon-order me-2"></i>All Invoices
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item fs-15 py-1" to="/all-crate-credits">
                    <i className="icon icon-order me-2"></i>All Crate Credits
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item fs-15 py-1" to="/all-produce-credits">
                    <i className="icon icon-order me-2"></i>All Produce Credits
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown px-3">
              <a
                href="#"
                className="nav-link text-white fs-15 dropdown-toggle"
                id="utilities"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Utilities
              </a>
              <ul
                className="dropdown-menu border-0 shadow-lg"
                aria-labelledby="utilities"
                style={{ minWidth: "12rem" }}
              >
                <li>
                  <Link className="dropdown-item fs-15 py-1 mb-1" to="/agents">
                    <i className="icon icon-agent me-2"></i> Agents
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/containers"
                  >
                    <i className="icon icon-container me-2"></i>Containers
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/customers"
                  >
                    <i className="icon icon-customer me-2"></i>Customers
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/products"
                  >
                    <i className="icon icon-product me-2"></i>Products
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item fs-15 py-1 mb-1" to="/units">
                    <i className="icon icon-unit me-2"></i>Units
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/crate-suppliers"
                  >
                    <i className="icon icon-unit me-2"></i>Crate suppliers
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item fs-15 py-1 mb-1"
                    to="/categories"
                  >
                    <i className="icon icon-unit me-2"></i>Categories
                  </Link>
                </li>
              </ul>
            </li>
            <li className="ms-auto fs-14 text-white">
              <i className="icon icon-calendar me-1 text-white"></i>
              {`${newDate.getDate()} ${monthNames[newDate.getMonth()]}, ${newDate.getFullYear()}`}
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}
export default Header;
